"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var creationDateTSBuilder = function creationDateTSBuilder(params) {
  var recentlyAdded = params.recentlyAdded;

  if (!recentlyAdded || recentlyAdded === 'all') {
    return '';
  }

  var daysBack = {
    '1-day': 1,
    '3-days': 3,
    '7-days': 7,
    '14-days': 14
  }[recentlyAdded];
  var creationDate = (0, _date.addDays)((0, _date.getToday)(), -daysBack);
  var creationDateTS = new Date(creationDate).getTime() / 1000;
  return "creationDateTS>=" + creationDateTS;
};

var _default = creationDateTSBuilder;
exports["default"] = _default;